import React, { ChangeEvent, useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Row, Col, Image, Form, Button } from "react-bootstrap";
import Input from "../../components/Form/Input";
import Logo1 from "../../assets/images/logo1.png";
import ImageSrc from "../../assets/images/Group_252.png";
import useWindowDimensions from "../../helpers/GetCurrentWidth";
import Alert from "../../helpers/Alert";

import { updatePasswordByToken } from "../../services/UserService";
import PublicBackground from "../../components/PublicBackground";

import Success from "../../assets/images/success.svg"

import "./index.css";
import "./success.css";

interface TypeData {
  email: string;
  token: string;
  password: string;
  passwordConfirm: string;
}

export default function ResetPassword() {
  let history = useNavigate();

  const [data, setData] = useState<TypeData>({
    password: "",
    passwordConfirm: "",
    email: "",
    token: "",
  });
  const { width } = useWindowDimensions();
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    try {
      const paramsString = location.search;
      const params = new URLSearchParams(paramsString);
      const email = params.get("e") || "";
      const token = params.get("t") || "";

      setData({ ...data, email, token });
    } catch (error) {
      Alert(false, "E-mail ou token não encontrado!");
      history("/login");
    }
  }, []);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };
  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    const is_valid = validation();
    is_valid && resetPasswordUser();
  };

  const validation = () => {
    const { password, passwordConfirm } = data;

    // Validações
    if (password.length < 6) {
      Alert(false, "Senha precisar ter 6 ou mais caracteres");
    } else if (password !== passwordConfirm) {
      Alert(false, "Confirmação de senha precisa ser igual a senha");
    } else {
      return true;
    }
  };

  const resetPasswordUser = () => {
    const { email, token, password } = data;
    updatePasswordByToken(email, token, password)
      .then((res) => {
        setShowConfirmation(true)
        // Alert(true, res.data.message);
        // history.push(`/login`);
      })
      .catch((err) => {
        Alert(false, err.response.data.error);
      });
  };

  return (
    <PublicBackground>
      {showConfirmation ? (
        <div className="success--content-wrapper">
          <img
            className="success--image-content"
            src={Success}
            alt=""
          />
          <div className="success--content-container">
            <div className="success--content-description">
              Senha atualizada com sucesso
          </div>
            <button onClick={e => history('/login')} className="success--button">Voltar para o login</button>
          </div>
        </div>
      ) : (
          <>
            <div className="password-title">Crie sua senha</div>
            <div className="password--form-container">
              <Form onSubmit={handleSubmit} className="password-form">
                <Input
                  className="signup-input"
                  name="password"
                  label="Nova senha"
                  type="password"
                  placeholder={"Digite sua nova senha"}
                  data={data.password}
                  setData={handleInputChange}
                  required={true}
                />
                <Input
                  className="signup-input"
                  name="passwordConfirm"
                  label="Confirmar senha"
                  type="password"
                  placeholder={"Digite sua senha novamente"}
                  data={data.passwordConfirm}
                  setData={handleInputChange}
                  required={true}
                />
                <button type="submit" className='password-button'>
                  salvar senha
          </button>
                <div className="l-inline-center">
                  <NavLink to="/login">
                    <span className="password-signup">voltar para login </span>
                  </NavLink>
                </div>
              </Form>
            </div>
          </>
        )}
    </PublicBackground>
  );
}
